<div class="reporting-container">
  <div class="d-flex flex-column flex-grow-1 h-100">

    <div class="tab-bar d-flex">
      <div class="title">Reporting</div>

      <div class="tabs">
        <a routerLink="viewer" routerLinkActive="active" role="button" class="tab" data-testid="developer-reporting-viewer">
          <div class="m-0 p-0">Viewer</div>
        </a>

        <a routerLink="designer" routerLinkActive="active" role="button" class="tab" data-testid="developer-reporting-designer">
          <div class="m-0 p-0">Designer</div>
        </a>
      </div>

    </div>

    <div class="child-container p-2 m-0">
      <router-outlet></router-outlet>
    </div>
  </div>
</div>


// WEBPACK FOOTER //
// ./src/app/developer/reporting/reporting.component.html